export default __webpack_public_path__ + "media/images/slider-bg-20c6a8743784429c61c09d40864aa7f9.png";